import { Col, Container, Row, Stack } from "react-bootstrap";
import { renderSortIcon } from "../helperRenders";

export default function SongSearchHeader({ sortConfig, requestSort, showItemId = false }) {
    return (
        <Container fluid>
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 rounded-2 fs-8-xs table-header user-select-none h-100">
                <Col xs={3} xl onClick={requestSort ? () => requestSort("artist") : null} className=" align-self-center">
                    <Stack direction="horizontal">
                        <span>Artist</span>
                        <span className="col-1">{renderSortIcon("artist", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={3} xl onClick={requestSort ? () => requestSort("title") : null} className=" align-self-center">
                    <Stack direction="horizontal">
                        <span>Title</span>
                        <span className="col-1">{renderSortIcon("title", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={3} xl={2} onClick={requestSort ? () => requestSort("release_year") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">Release Year</span>
                        <span className="col-1">{renderSortIcon("release_year", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={3} xl={2} onClick={requestSort ? () => requestSort("spins") : null} className=" align-self-center">
                    <Stack direction="horizontal" className=" justify-content-center">
                        <span className="offset-1 text-center">Total Spins</span>
                        <span className="col-1">{renderSortIcon("spins", sortConfig)}</span>
                    </Stack>
                </Col>
                {showItemId && (
                    <Col xs={3} xl={2} onClick={requestSort ? () => requestSort("item_id") : null} className=" align-self-center d-none d-xl-block">
                        <Stack direction="horizontal" className=" justify-content-center">
                            <span className="offset-1 text-center">Item ID</span>
                            <span className="col-1">{renderSortIcon("item_id", sortConfig)}</span>
                        </Stack>
                    </Col>
                )}
                <Col xs={1} className=" text-center d-none d-xl-block">
                    Trend
                </Col>
            </Row>
        </Container>
    );
}
